import { HStack } from "components/ui";
import SwitchBasic from "components/ui/SwitchBasic";
import React from "react";

type RechargeableFieldProps = {
  isChecked: boolean;
  onChange: (newValue: boolean) => void;
};

const RechargeableField = ({ isChecked, onChange }: RechargeableFieldProps) => {
  return (
    <HStack gap="$2" alignItems="center">
      <SwitchBasic
        borderBottomWidth={0}
        text="Rechargeable"
        defaultValue={isChecked}
        value={isChecked}
        onChange={onChange}
      />
    </HStack>
  );
};

export default RechargeableField;
